(function(){
  window.initProductGallery = function initProductGallery(root){
    if (!root) return;
    const track = root.querySelector('.product-gallery__track');
    const slides = Array.from(root.querySelectorAll('.product-gallery__slide'));
    const thumbs = Array.from(root.querySelectorAll('.product-thumb'));
    const btnPrev = root.querySelector('.product-gallery__btn--prev');
    const btnNext = root.querySelector('.product-gallery__btn--next');
    if (!track || slides.length === 0) return;

    function clamp(i){ return Math.max(0, Math.min(i, slides.length - 1)); }

    function getActiveIndex(){
      const rect = track.getBoundingClientRect();
      let bestIdx = 0, bestDist = Infinity;
      slides.forEach((s, i) => {
        const r = s.getBoundingClientRect();
        const dist = Math.abs((r.left + r.right)/2 - (rect.left + rect.right)/2);
        if (dist < bestDist){ bestDist = dist; bestIdx = i; }
      });
      return bestIdx;
    }

    // --- Media controls (videos auto-play on active slide) ---
    function playIframe(iframe){
      const src = (iframe && iframe.getAttribute('src')) || '';
      try {
        if (src.includes('youtube.com') || src.includes('youtu.be')){
          iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
          iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
        } else if (src.includes('vimeo.com')){
          iframe.contentWindow && iframe.contentWindow.postMessage({ method: 'play' }, '*');
          iframe.contentWindow && iframe.contentWindow.postMessage({ method: 'setVolume', value: 1 }, '*');
        }
      } catch(_){}
    }
    function pauseIframe(iframe){
      const src = (iframe && iframe.getAttribute('src')) || '';
      try {
        if (src.includes('youtube.com') || src.includes('youtu.be')){
          iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        } else if (src.includes('vimeo.com')){
          iframe.contentWindow && iframe.contentWindow.postMessage({ method: 'pause' }, '*');
        }
      } catch(_){}
    }
    function updateMediaForIndex(idx){
      slides.forEach((s, i) => {
        const video = s.querySelector('video');
        const iframe = s.querySelector('iframe');
        if (i === idx){
          if (video){
            try {
              video.loop = true; video.playsInline = true;
              video.removeAttribute('muted'); video.muted = false; video.setAttribute('playsinline','');
              video.play().catch(()=>{});
            } catch(_){}
          } else if (iframe){
            // allow autoplay where possible
            const allow = (iframe.getAttribute('allow') || '');
            if (!/autoplay/.test(allow)) iframe.setAttribute('allow', (allow ? allow + ';' : '') + 'autoplay');
            playIframe(iframe);
          }
        } else {
          if (video){ try { video.pause(); video.currentTime = 0; } catch(_){} }
          if (iframe){ pauseIframe(iframe); }
        }
      });
    }

    function setActiveByIndex(idx, behavior='smooth'){
      idx = clamp(idx);
      slides[idx].scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
      thumbs.forEach(t => t.setAttribute('aria-current','false'));
      const t = thumbs.find(btn => parseInt(btn.getAttribute('data-thumb-index'),10) === idx);
      if (t) t.setAttribute('aria-current','true');
      // proactively update media
      updateMediaForIndex(idx);
    }

    thumbs.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-thumb-index') || '0', 10);
        setActiveByIndex(idx);
      });
    });

    // Buttons
    if (btnPrev) btnPrev.addEventListener('click', () => setActiveByIndex(getActiveIndex()-1));
    if (btnNext) btnNext.addEventListener('click', () => setActiveByIndex(getActiveIndex()+1));

    // Keyboard
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft'){ e.preventDefault(); setActiveByIndex(getActiveIndex()-1); }
      if (e.key === 'ArrowRight'){ e.preventDefault(); setActiveByIndex(getActiveIndex()+1); }
    });

    // Touch swipe
    let startX = 0, isTouching = false;
    track.addEventListener('touchstart', (e) => { if (!e.touches || e.touches.length !== 1) return; isTouching = true; startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (!isTouching) return; isTouching = false;
      const endX = (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || startX;
      const delta = endX - startX; const threshold = 40;
      if (Math.abs(delta) > threshold){ if (delta < 0) setActiveByIndex(getActiveIndex()+1); else setActiveByIndex(getActiveIndex()-1); }
      else setActiveByIndex(getActiveIndex());
    });

    // Sync thumb active on scroll and update media
    let ticking = false;
    function onScroll(){ if (ticking) return; ticking = true; requestAnimationFrame(() => { const idx = getActiveIndex(); thumbs.forEach(t => t.setAttribute('aria-current','false')); const t = thumbs.find(btn => parseInt(btn.getAttribute('data-thumb-index'),10) === idx); if (t) t.setAttribute('aria-current','true'); updateMediaForIndex(idx); ticking = false; }); }
    track.addEventListener('scroll', onScroll, { passive: true });

    // Snap to first slide on load
    setTimeout(() => { setActiveByIndex(0, 'auto'); updateMediaForIndex(0); }, 0);
  };

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-product-gallery]').forEach(window.initProductGallery);
  });
})();

(function() {
  const header = document.querySelector('.luxe-header');
  const toggle = document.querySelector('.luxe-header__mobile-toggle');
  const nav = document.getElementById('SiteNav');

  function onScroll() {
    if (!header) return;
    const scrolled = window.scrollY > 10;
    header.classList.toggle('scrolled', scrolled);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', onScroll);

  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  }

  // Mobile search popover
  const searchToggle = document.querySelector('.luxe-search-toggle');
  const searchPopover = document.getElementById('SearchPopover');
  const mobileSearchInput = document.getElementById('MobileSearchInput');

  function openSearch(){
    if (!searchPopover) return;
    searchPopover.hidden = false;
    // force reflow for transition
    searchPopover.getBoundingClientRect();
    searchPopover.classList.add('is-open');
    if (mobileSearchInput) mobileSearchInput.focus();
    document.addEventListener('keydown', onEscClose);
    document.addEventListener('click', onOutsideClick);
  }
  function closeSearch(){
    if (!searchPopover) return;
    searchPopover.classList.remove('is-open');
    setTimeout(()=>{ searchPopover.hidden = true; }, 250);
    document.removeEventListener('keydown', onEscClose);
    document.removeEventListener('click', onOutsideClick);
    if (searchToggle) searchToggle.setAttribute('aria-expanded','false');
  }
  function onEscClose(e){ if (e.key === 'Escape') closeSearch(); }
  function onOutsideClick(e){
    if (!searchPopover.contains(e.target) && !searchToggle.contains(e.target)) closeSearch();
  }
  if (searchToggle && searchPopover){
    searchToggle.addEventListener('click', function(){
      const expanded = this.getAttribute('aria-expanded') === 'true';
      if (expanded) { closeSearch(); }
      else { this.setAttribute('aria-expanded','true'); openSearch(); }
    });
  }
})();

(function(){
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  function moneyFormat(cents, money_format){
    const value = (cents/100).toFixed(2);
    return (money_format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
  }

  // Predictive search
  function debounce(fn, wait){ let t; return function(...args){ clearTimeout(t); t = setTimeout(()=>fn.apply(this,args), wait); }; }
  async function fetchPredictive(term){
    const q = (term || '').trim();
    if (!q) return null;
    const url = new URL(`${location.protocol}//${location.host}/search/suggest.json`);
    url.searchParams.set('q', q);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');
    try {
      const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      return await res.json();
    } catch(_) { return null; }
  }
  function renderSuggest(root, data, term){
    if (!root) return;
    if (!data || !data.resources || !data.resources.results || !data.resources.results.products) { root.innerHTML=''; root.hidden=true; return; }
    const prods = data.resources.results.products || [];
    if (prods.length === 0){ root.innerHTML=''; root.hidden=true; return; }
    const list = document.createElement('div');
    list.className = 'suggest-list';
    prods.forEach((p, idx) => {
      const a = document.createElement('a');
      a.className = 'suggest-item';
      a.setAttribute('role','option');
      a.setAttribute('aria-selected', String(idx===0));
      a.href = p.url || (`/products/${encodeURIComponent(p.handle)}`);
      a.innerHTML = `
        <div class="suggest-thumb">${p.image ? `<img src="${p.image}" alt="${(p.title||'').replace(/"/g,'&quot;')}">` : ''}</div>
        <div class="suggest-title">${p.title || ''}</div>
        <div class="suggest-price">${(p.price_min && typeof p.price_min === 'number') ? new Intl.NumberFormat(undefined, { style: 'currency', currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(p.price_min/100) : ''}</div>
      `;
      list.appendChild(a);
    });
    const footer = document.createElement('div');
    footer.className = 'suggest-footer';
    const allLink = document.createElement('a');
    allLink.className = 'suggest-view-all';
    allLink.href = `/search?q=${encodeURIComponent(term || '')}`;
    allLink.textContent = 'View all results';
    footer.appendChild(allLink);

    root.innerHTML = '';
    root.appendChild(list);
    root.appendChild(footer);
    root.hidden = false;
  }
  function bindPredictive(input, root){
    if (!input || !root) return;
    const update = debounce(async () => {
      const term = input.value || '';
      if (!term.trim()){ root.hidden = true; root.innerHTML = ''; input.setAttribute('aria-expanded','false'); return; }
      const data = await fetchPredictive(term);
      renderSuggest(root, data, term);
      input.setAttribute('aria-expanded', String(!root.hidden));
    }, 180);
    input.addEventListener('input', update);
    input.addEventListener('focus', update);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape'){ root.hidden = true; input.setAttribute('aria-expanded','false'); }
    });
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target) && e.target !== input){ root.hidden = true; input.setAttribute('aria-expanded','false'); }
    });
  }

  // Bind after DOM ready
  document.addEventListener('DOMContentLoaded', function(){
    bindPredictive(document.getElementById('HeaderSearchInput'), document.getElementById('HeaderSearchSuggest'));
    bindPredictive(document.getElementById('MobileSearchInput'), document.getElementById('MobileSearchSuggest'));
  });

  function openDrawer(){
    const drawer = $('.cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const advToggle = $('.cart-drawer__adv-toggle');
    const adv = $('#CartDrawerAdvanced');
    if (advToggle && adv){
      advToggle.setAttribute('aria-expanded','false');
      adv.classList.remove('is-open');
    }
    refreshStoreCreditUI();
  }
  function closeDrawer(){
    const drawer = $('.cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function getMoneyFormatFromDrawer(drawer){
    let fmt = drawer.getAttribute('data-money-format');
    try { fmt = JSON.parse(fmt); } catch(e) {}
    return fmt;
  }

  function uniqueNonEmpty(arr){
    return Array.from(new Set((arr || []).map(v => (v || '').toString().trim()).filter(Boolean)));
  }

  function getCodes(cart){
    const fromApps = (cart && cart.cart_level_discount_applications || []).map(a => a && a.title);
    const fromCodes = (cart && cart.discount_codes || []).map(dc => (dc && (dc.code || dc.title)));
    return uniqueNonEmpty([...(fromApps || []), ...(fromCodes || [])]);
  }

  async function updateCartDiscount(value){
    const fd = new FormData();
    fd.append('discount', value);
    const res = await fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/' }cart/update.js`, {
      method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
    });
    try { return await res.json(); } catch(_) { return null; }
  }

  function setDrawerDiscountUI(cart){
    const appliedWrap = $('#CartDrawerDiscountApplied');
    const group = $('#CartDrawerDiscountGroup');
    const chipsWrap = $('#CartDrawerDiscountChips');
    const errorEl = $('#CartDrawerDiscountError');
    if (!appliedWrap || !group) return;

    if (chipsWrap) chipsWrap.innerHTML = '';

    const codes = getCodes(cart);
    if (codes.length > 0){
      if (chipsWrap){
        codes.forEach(code => {
          const chip = document.createElement('span');
          chip.className = 'discount-chip';
          chip.setAttribute('data-code', code);
          chip.innerHTML = `
            <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
            <span class="discount-code-text">${code}</span>
            <a href="#" class="discount-chip__remove" data-discount-remove data-code="${code}" aria-label="Remove ${code}">&times;</a>
          `;
          chipsWrap.appendChild(chip);
        });
      }
      appliedWrap.hidden = false;
      group.hidden = true;
      if (errorEl) errorEl.hidden = true;
    } else {
      appliedWrap.hidden = true;
      group.hidden = false;
    }
  }

  function renderCart(cart){
    const drawer = $('.cart-drawer');
    if (!drawer) return;
    const itemsWrap = $('.cart-drawer__items', drawer);
    const empty = $('.cart-drawer__empty', drawer);
    const subtotalEl = $('.cart-drawer__subtotal-value', drawer);
    const itemsSubtotalEl = $('.cart-drawer__items-subtotal-value', drawer);
    const discountRow = $('.cart-drawer__discount-row', drawer);
    const discountValueEl = $('.cart-drawer__discount-value', drawer);
    const checkoutBtn = $('.cart-checkout', drawer);
    const moneyFmt = getMoneyFormatFromDrawer(drawer);

    itemsWrap.innerHTML = '';
    if (!cart.items || cart.items.length === 0){
      empty.hidden = false;
      checkoutBtn.setAttribute('aria-disabled', 'true');
    } else {
      empty.hidden = true;
      checkoutBtn.removeAttribute('aria-disabled');
      cart.items.forEach(item => {
        const li = document.createElement('div');
        li.className = 'cart-item';
        li.innerHTML = `
          <a class="cart-item__media" href="${item.url}">
            <img class="cart-item__image" src="${item.image}?width=300" alt="${item.title.replace(/\\"/g,'&quot;')}">
          </a>
          <div class="cart-item__content">
            <a class="cart-item__title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class=\"cart-item__options\">${item.variant_title}</div>` : ''}
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
          <div class="cart-item__controls">
            <div class="cart-qty" data-key="${item.key}">
              <button type="button" class="qty-dec" aria-label="Decrease">-</button>
              <input type="number" min="0" value="${item.quantity}">
              <button type="button" class="qty-inc" aria-label="Increase">+</button>
            </div>
            <div class="cart-item__price">${moneyFormat(item.final_line_price, moneyFmt)}</div>
          </div>`;
        itemsWrap.appendChild(li);
      });
    }
    if (itemsSubtotalEl) itemsSubtotalEl.textContent = moneyFormat(cart.items_subtotal_price || 0, moneyFmt);
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price || 0, moneyFmt);

    // Only show discount row when actual discount exists
    if (discountRow && discountValueEl){
      if ((cart.total_discount || 0) > 0){
        discountRow.hidden = false;
        discountValueEl.textContent = '-' + moneyFormat(cart.total_discount, moneyFmt);
      } else {
        discountRow.hidden = true;
      }
    }

    setDrawerDiscountUI(cart);
  }

  async function fetchCart(){
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function changeLine(key, quantity){
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  async function fetchStoreCreditMoney(){
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', 'account-loyalty-balance');
      const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) return null;
      const json = await res.json();
      const html = json['account-loyalty-balance'];
      if (!html) return null;
      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      const el = tmp.querySelector('#AccountLoyaltyBalanceData');
      if (!el) return null;
      return el.getAttribute('data-balance-money-with-currency') || el.getAttribute('data-balance-money') || null;
    } catch(e){ return null; }
  }

  async function refreshStoreCreditUI(){
    const balanceStr = await fetchStoreCreditMoney();
    const drawerTarget = $('#CartDrawerCreditBalance');
    if (drawerTarget) drawerTarget.textContent = balanceStr || '-';
  }

  function attachEvents(){
    document.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-fullview]')) return;

      const cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (cartLink){
        e.preventDefault();
        const cart = await fetchCart();
        renderCart(cart);
        openDrawer();
        return;
      }
      if (e.target.matches('[data-cart-close]')){
        e.preventDefault();
        closeDrawer();
        return;
      }
      const qtyBtn = e.target.closest('.cart-qty button');
      if (qtyBtn){
        const wrap = qtyBtn.closest('.cart-qty');
        const input = wrap.querySelector('input');
        const key = wrap.getAttribute('data-key');
        let val = parseInt(input.value || '0', 10);
        if (qtyBtn.classList.contains('qty-inc')) val += 1; else val = Math.max(0, val - 1);
        input.value = val;
        const cart = await changeLine(key, val);
        renderCart(cart);
        return;
      }
      if (e.target.matches('.cart-item__remove')){
        e.preventDefault();
        const key = e.target.getAttribute('data-key');
        const cart = await changeLine(key, 0);
        renderCart(cart);
        return;
      }
      const drawerApply = e.target.closest('#CartDrawerDiscountApply');
      if (drawerApply){
        e.preventDefault();
        const input = $('#CartDrawerDiscountCode');
        const code = (input && input.value || '').trim();
        if (!code) return;
        await updateCartDiscount(code);
        const url = new URL(window.location.href);
        url.searchParams.set('open_cart','1');
        window.location.replace(url.toString());
        return;
      }
      const drawerChipRemove = e.target.closest('.cart-drawer .discount-chip__remove, .cart-drawer [data-discount-remove]');
      if (drawerChipRemove){
        e.preventDefault();
        const chip = drawerChipRemove.closest('.discount-chip');
        const code = chip && (chip.getAttribute('data-code') || (chip.querySelector('.discount-code-text') && chip.querySelector('.discount-code-text').textContent.trim()));
        const cart = await fetchCart();
        const current = (cart.discount_codes || []).map(dc => (dc && (dc.code || dc.title))).filter(Boolean);
        const remaining = current.filter(c => (c || '').toLowerCase() !== (code || '').toLowerCase());
        await updateCartDiscount(remaining.join(','));
        const url = new URL(window.location.href);
        url.searchParams.set('open_cart','1');
        window.location.replace(url.toString());
        return;
      }
      const checkoutBtn = e.target.closest('.cart-checkout');
      if (checkoutBtn){
        const disabled = checkoutBtn.getAttribute('aria-disabled') === 'true';
        if (disabled){
          e.preventDefault();
          return;
        }
        const href = checkoutBtn.getAttribute('href') || '/checkout';
        e.preventDefault();
        window.location.href = href;
        return;
      }
      const advToggle = e.target.closest('.cart-drawer__adv-toggle');
      if (advToggle){
        e.preventDefault();
        const adv = document.getElementById('CartDrawerAdvanced');
        const expanded = advToggle.getAttribute('aria-expanded') === 'true';
        advToggle.setAttribute('aria-expanded', String(!expanded));
        if (adv) adv.classList.toggle('is-open', !expanded);
        return;
      }
      if (e.target.matches('#CartDrawerCreditApply') || e.target.matches('#CartPageCreditApply')){
        e.preventDefault();
        window.location.href = '/checkout';
        return;
      }
    });

    // Keep balance fresh when tab gains focus
    window.addEventListener('focus', refreshStoreCreditUI);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshStoreCreditUI(); });
  }

  async function initDrawerOnLoad(){
    const params = new URLSearchParams(location.search);
    const open = params.get('open_cart') === '1';
    if (open){
      const cart = await fetchCart();
      renderCart(cart);
      openDrawer();
    }
  }

  function init(){
    attachEvents();
    initDrawerOnLoad();
    // Also populate credit balance on general load if elements exist
    refreshStoreCreditUI();
  }

  document.addEventListener('DOMContentLoaded', init);
})();

(function(){
  function initSlider(root){
    const track = root && root.querySelector('.product-slider__track');
    if (!track) return;
    function getGap(){
      const s = getComputedStyle(track);
      return parseFloat(s.gap || s.gridColumnGap || s.columnGap || '0');
    }
    function getStep(){
      const first = track.querySelector('.card-product');
      return first ? first.getBoundingClientRect().width + getGap() : 320 + getGap();
    }
    const prev = root.querySelector('.slider-btn--prev');
    const next = root.querySelector('.slider-btn--next');
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: getStep(), behavior: 'smooth' }));
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-slider]')?.forEach(initSlider);
  });
})();

(function(){
  function initHeroRotator(){
    const rotator = document.querySelector('.hero-rotator');
    if (!rotator) return;
    const imgs = Array.from(rotator.querySelectorAll('.hero-rotator__img'));
    if (imgs.length <= 1) return;
    const interval = parseInt(rotator.getAttribute('data-interval') || '5000', 10);
    let idx = imgs.findIndex(i => i.classList.contains('is-active'));
    if (idx < 0) idx = 0;
    setInterval(() => {
      const curr = imgs[idx];
      idx = (idx + 1) % imgs.length;
      const next = imgs[idx];
      if (curr) curr.classList.remove('is-active');
      if (next) next.classList.add('is-active');
    }, Math.max(1500, interval));
  }
  document.addEventListener('DOMContentLoaded', initHeroRotator);
})();

(function(){
  function initAccountMenu(){
    const toggle = document.querySelector('.luxe-account__toggle');
    const menu = document.getElementById('AccountMenu');
    if (!toggle || !menu) return;
    function open(){
      menu.hidden = false;
      toggle.setAttribute('aria-expanded','true');
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKey);
    }
    function close(){
      menu.hidden = true;
      toggle.setAttribute('aria-expanded','false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
    }
    function onDocClick(e){
      if (menu.contains(e.target) || toggle.contains(e.target)) return;
      close();
    }
    function onKey(e){ if (e.key === 'Escape') close(); }
    toggle.addEventListener('click', function(){
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) close(); else open();
    });
  }
  document.addEventListener('DOMContentLoaded', initAccountMenu);
})();


// Quick View modal (unified controller)
(function(){
  const modal = document.getElementById('QuickViewModal');
  if (!modal) return;
  const content = modal.querySelector('[data-qv-content]');
  const dialog = modal.querySelector('.qv-modal__dialog');

  // Dynamic viewport height handling for mobile browser chrome (bottom bars)
  const rootStyle = document.documentElement.style;
  const setQvVH = () => {
    const h = (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0;
    if (h) rootStyle.setProperty('--qv-vh', h + 'px');
  };
  const vhListeners = [];
  function bindVh(){
    setQvVH();
    if (window.visualViewport){
      const onVVResize = () => setQvVH();
      const onVVScroll = () => setQvVH();
      window.visualViewport.addEventListener('resize', onVVResize);
      window.visualViewport.addEventListener('scroll', onVVScroll);
      vhListeners.push(['vv-resize', onVVResize], ['vv-scroll', onVVScroll]);
    }
    const onWinResize = () => setQvVH();
    const onOrient = () => setQvVH();
    window.addEventListener('resize', onWinResize);
    window.addEventListener('orientationchange', onOrient);
    vhListeners.push(['win-resize', onWinResize], ['orient', onOrient]);
  }
  function unbindVh(){
    if (window.visualViewport){
      const r = vhListeners.find(x => x[0] === 'vv-resize');
      const s = vhListeners.find(x => x[0] === 'vv-scroll');
      if (r) window.visualViewport.removeEventListener('resize', r[1]);
      if (s) window.visualViewport.removeEventListener('scroll', s[1]);
    }
    const wr = vhListeners.find(x => x[0] === 'win-resize');
    const wo = vhListeners.find(x => x[0] === 'orient');
    if (wr) window.removeEventListener('resize', wr[1]);
    if (wo) window.removeEventListener('orientationchange', wo[1]);
    vhListeners.length = 0;
  }

  async function fetchQuickView(handle){
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}?sections=product-quickview`, { headers: { 'Accept': 'application/json' } });
      if (res.ok){ const json = await res.json(); if (json && json['product-quickview']) return json['product-quickview']; }
    } catch(_){ }
    try {
      const res2 = await fetch(`/products/${encodeURIComponent(handle)}?view=quickview`, { headers: { 'Accept': 'text/html' } });
      if (res2.ok){ return await res2.text(); }
    } catch(_){ }
    return null;
  }

  function extractSection(html){ const tmp = document.createElement('div'); tmp.innerHTML = (html||'').trim(); const sec = tmp.querySelector('.quickview-product'); return sec ? sec.outerHTML : html; }
  function pauseEmbeds(root){
    if (!root) return;
    root.querySelectorAll('video').forEach(v => { try { v.pause(); v.currentTime = 0; } catch(_){} });
    root.querySelectorAll('iframe').forEach(ifr => {
      const src = (ifr.getAttribute('src')||'');
      try {
        if (src.includes('youtube.com') || src.includes('youtu.be')){ ifr.contentWindow && ifr.contentWindow.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args: []}), '*'); }
        else if (src.includes('vimeo.com')) { ifr.contentWindow && ifr.contentWindow.postMessage({ method:'pause' }, '*'); }
      } catch(_){}

    });
  }
  function openModal(){ modal.hidden = false; modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; bindVh(); }
  function closeModal(){ pauseEmbeds(content); modal.hidden = true; modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if (content) content.innerHTML=''; unbindVh(); }

  // Open handler (delegated)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quickview-open]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-handle'); if (!handle) return;
    openModal();
    if (!content) return;
    content.innerHTML = '<div style="padding:16px; text-align:center;">Loading...</div>';
    const html = await fetchQuickView(handle); if (!html){ closeModal(); return; }
    content.innerHTML = extractSection(html);
    try { content.querySelectorAll('[data-product-gallery]').forEach(window.initProductGallery); } catch(_){ }
  });

  // Close handlers
  modal.addEventListener('click', (e) => {
    if (e.target.classList.contains('qv-modal__backdrop') || e.target.closest('[data-qv-close]')){ e.preventDefault(); closeModal(); }
  });
  if (dialog){
    dialog.addEventListener('click', (e) => {
      if (e.target.closest('[data-qv-close]')){ e.preventDefault(); closeModal(); return; }
      e.stopPropagation();
    });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
})();
